<template>
    <div class="list">
        <div v-for="(item,index) in list">
            <div v-if="item.news_type!=4" class="media media-1">

                <div class="media-left">
                    <i v-show="item.view_tag">{{item.view_tag}}</i>
                    <a v-show="item.open_type==1" :href="item.third_url" target="_blank">
                        <img v-lazy="{
                                loading: lazyLoading,
                                error: lazyLoading,
                                src: item.img_url[0]
                              }" data-src="/public/w/img/wap/loading.png">
                    </a>
                    <a v-show="item.open_type==0" :href="`/news/${item.id}`" target="_blank">
                        <img v-lazy="{
                            loading: lazyLoading,
                            error: lazyLoading,
                            src: item.img_url[0]
                          }" data-src="/public/w/img/wap/loading.png">
                    </a>
                </div>
                <div class="media-body">
                    <a v-show="item.open_type==1" :href="item.third_url" target="_blank">
                        <h1 class="media-heading textone-1" v-html="item.title"></h1>
                    </a>
                    <a v-show="item.open_type==0" :href="`/news/${item.id}`" target="_blank">
                        <h1 class="media-heading textone-1" v-html="item.title"></h1>
                    </a>
                    <p class="textTow">{{item.abstract}}</p>
                    <p class="last">
                        <span v-show="item.source">来源：{{item.source}}</span>
                        <span v-if="item.author && clientId==410600">编辑：{{item.author}}</span>
                        <span v-if="item.author && clientId!==410600">作者：{{item.author}}</span>
                        <span v-show='item.released_at'>{{friendlyTime(item.released_at,'mohu',1)}}</span>
                        <span class="views" v-show="(item.views||item.views==0)&&(!(clientId==321300||clientId==320100))">{{item.views}}人阅读</span>
                    </p>
                </div>
            </div>
            <div v-if="item.news_type==4" class="media media-2">
                <div class="media-left">
                    <a :href="`/news/topic/${item.id}`" target="_blank">
                        <img class="media-object" v-lazy="{
                            loading: lazyLoading,
                            error: lazyLoading,
                            src: item.img_url[0]
                          }" data-src="/public/w/img/wap/loading.png">
                    </a>
                </div>
                <div class="media-body elip">{{item.title}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import friendlyTime from 'asset/js/utils/friendlyTime';
    import Vue from 'vue';
    import VueLazyload from 'vue-lazyload';

    Vue.use(VueLazyload);

    export default {
        props: ['title', 'list', 'clientId'],
        computed: {
            lazyLoading() {
                if (this.clientId) {
                    return `/public/w/img/${this.clientId}/loading_news.png`;
                } else {
                    return '/public/w/default/loading_news.png';
                }
            }
        },
        data() {
            return {
                friendlyTime,
                loadingPic: {
                    410600: {
                        logo: '/public/w/img/320598/loading_news.png'
                    },
                    320598: {
                        logo: '/public/w/img/410600/loading_news.png'
                    }
                }
            }
        },
        methods: {

        }
    };
</script>


// WEBPACK FOOTER //
// app/web/component/web/news-list/public-list.vue